module.exports = __webpack_public_path__ + "static/img/mystery.36c2b47.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/mystery.png
// module id = LXtP
// module chunks = 1